import { observer } from 'mobx-react';
import { Component } from 'react';
import OrderCartProduct from '../../components/OrderCartProduct/OrderCartProduct';
import { withCheckoutStore } from '../../context';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath, formatPrice } from 'src/utils/formatter';
import { CheckoutStore } from '~/mobx/checkoutStore';
import { Icons } from '~/assets/fonts/Icons/icons';

// @ts-ignore
@withCheckoutStore
@observer
export default class OrderCartProducts extends Component<{ checkoutStore?: CheckoutStore }, {}> {
  get checkoutStore() {
    return this.props.checkoutStore!;
  }

  /**
   * Show all items that are in donation status
   */
  get isDonation() {
    return this.checkoutStore.dependencies.products
      .filter((item) => !item.is_donation)
      .map((product, index) => <OrderCartProduct key={`${product.id}-${index}`} product={product} />);
  }
  /**
   * Show hidden item (Donation) if there are 1 or more items in the cart for donation
   */
  get hiddenProduct() {
    const findDonation = this.checkoutStore.dependencies.products.findIndex((item) => item.is_donation);

    if (findDonation !== -1) {
      return (
        <div className="d-flex align-items-baseline full-width">
          <div className="d-flex flex-1 flex-column color-dark text-pointer mr-2 py-3">
            <div className="d-flex justify-content-between align-items-baseline">
              <span className="text-size-16 family-semibold">{localeStore.t('donation')}</span>
              <span className="text-size-12 family-semibold text-nowrap ml-2">
                {formatPrice(this.checkoutStore.calculator.donation_subtotal || 0)}
              </span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    if (!this.checkoutStore.dependencies.products.length) {
      return (
        <div className="empty-list py-5">
          <img src={formatImagePath(`${Icons.NoResults}.svg`)} className="image__no-found mb-6" />
          <p className="color-gray2 text-center">{localeStore.t('txt_cart_empty')}</p>
        </div>
      );
    }

    return (
      <div className="d-flex flex-column">
        {this.hiddenProduct}
        {this.isDonation}
      </div>
    );
  }
}
